import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store/index.js';
import ApiService from './services/apiService';
import UserApiService from './services/user.api.js';
import 'typeface-open-sans/index.css';

Vue.config.productionTip = false;

Vue.prototype.$api = new ApiService();

var userAPI = new UserApiService();

const finishSetup = () => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const ssoParam = urlParams.get('sso');
    try {
      if ((ssoParam || null) !== null) {
        userAPI.sso(decodeURIComponent(ssoParam))
          .then((rs) => {
            if (rs !== null && rs.claims) {
              store.dispatch('auth/setUserProfile', rs.claims).then(setupApp());
            } else {
              setupApp();
            }
          }).catch((e) => {
            setupApp();
          });
      } else {
        setupApp();
      }
    } finally {
      // Change location back to root. We dont want to keep any query parameters around.
      // Route guard will redirect to #/marketplace or #/unauthorized if no token in state.
      var newurl = window.location.protocol + '//' + window.location.host;
      window.history.pushState({ path: newurl }, '', newurl);
    }
  } catch (ex) {
    setupApp();
  }
};

const setupApp = async () => {
  var isAuthenticated = store.state.auth.isAuthenticated;
  // No token in the store? Try pulling our cookie into the web app
  if ((isAuthenticated || null) == null || !isAuthenticated) {
    await userAPI.getAuthContext();
  }

  var app = new Vue({
    vuetify,
    store,
    render: h => h(App),
    router: router
  }).$mount('#app');
  return app;
};

finishSetup();
